<template>
  <div class="APIHomepage_more_detail">
    <div class="more-table-in">
      <div class="detail-breadcrumb">
        <span>
          Data Library / Data Dictionary /
          <span class="fromitem">{{ apiName }}</span>
        </span>
      </div>
      <div class="detail-info-header">
        <div class="info-title">{{ apiName }}</div>
        <div class="info-content borderbottom">
          <div class="flex_center_bettwen">
            <div>
              <div class="api-tag">
                <el-tag
                  v-for="(i, idx) in labelList"
                  :key="idx"
                  class="flex_center_start tag"
                  :type="idx == 0 ? 'warning' : ''"
                >
                  <img
                    v-if="idx == 0"
                    src="@/assets/images/dataServices/dataLibrary-img/tag.png"
                    alt=""
                  />
                  {{ i.labelName }}
                </el-tag>
              </div>
              <div class="api-date-version">Effective Date: {{$formatDateTime(apiInfo.updateTime, "yyyy-MM-dd hh:mm:ss") }}</div>
            </div>
            <el-button
              type="primary"
              class="api-download-btn"
              @click="DownloadnClick"
            >
              Download
            </el-button>
          </div>
        </div>
      </div>
      <div class="detail-info-block">
        <div class="info-title">Table Overview</div>
        <div class="info-content">
          <div class="info-desc noMarginbottom">
            <div>
              The Company Information table is the core master data table of the
              system, storing basic information about companies worldwide. Each
              record represents an independent corporate entity, including
              company identification information, contact information, and
              classification information, etc.
            </div>
            <div>
              <span class="boldfont">Primary Key: </span>company_id (Company ID)
            </div>
            <div>
              <span class="boldfont">Indexes: </span>Indexes are created on
              company_name, registration_number, tax_id
            </div>
          </div>
        </div>
      </div>
      <div class="detail-info-block">
        <div class="info-title">Field Definitions</div>
        <div class="info-content">
          <div class="info-desc"></div>
          <div class="bulkData-completed-table">
            <el-table
              ref="multipleTable"
              :data="requestParamsData"
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column
                v-for="col in tableColumns"
                :key="col.prop"
                :prop="col.prop"
                :label="col.label"
                :width="col.width"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="detail-info-block">
        <div class="info-title">Table Relationships</div>
        <div class="info-content">
          <div class="info-desc noMarginbottom">
            The relationships between the Company Information table and other
            main tables in the system are as follows:
            <ul class="info-desc-ul">
              <li>
                <span class="boldfont">One-to-many </span>relationship with the
                Financial Data table (financials.company_id →
                companies.company_id)
              </li>
              <li>
                <span class="boldfont">One-to-many </span>relationship with the
                Trade Records table (trade_records.company_id →
                companies.company_id)
              </li>
              <li>
                <span class="boldfont">One-to-one </span>relationship with the
                Company Details table (company_details.company_id →
                companies.company_id)
              </li>
              <li>
                <span class="boldfont">Many-to-many </span>relationship with the
                Ownership Structure table (through the ownership_relations
                junction table)
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getApiDataApiItemById,
  downLoadFileByItemId,
} from "@/api/dataServicesApi";
import { downloadFromBase64 } from "@/utils/date";
export default {
  name: "DataDictionaryDetail",
  props: [],
  data() {
    return {
      apiName: "", //二级名称
      apiInfo: {},
      labelList: [
        { labelName: "REST API" },
        { labelName: "Batch Processing" },
        { labelName: "JSON" },
      ],
      requestParamsData: [],
      tableColumns: [], // 动态表头
    };
  },
  components: {},
  computed: {},
  watch: {},
  created() {
    this.getApiDataApiItemByIdList();
  },
  mounted() {},
  methods: {
    // 获取详情数据
    async getApiDataApiItemByIdList() {
      console.log("this.$route", this.$route);
      this.id = this.$route.query.id;
      let res = await getApiDataApiItemById(`?id=${this.id}`);
      console.log("res---", res, res.code);
      if (res.code == 200) {
        this.apiInfo = JSON.parse(JSON.stringify(res.data));
        this.apiName = this.apiInfo.apiName;
        this.requestParamsData = JSON.parse(this.apiInfo.requestParams);
        let columnsArr = [];
        if (this.requestParamsData.length) {
          columnsArr = Object.keys(this.requestParamsData[0]);
          columnsArr.forEach((item) => {
            let obj = {
              prop: item,
              label: item,
            };
            this.tableColumns.push(obj);
          });
        }
        console.log(
          "this.apiInfo",
          this.apiInfo,
          this.requestParamsData,
          this.tableColumns
        );
      }
    },
    // 展示json对象
    formattedJson(data) {
      try {
        let obj = JSON.parse(data);
        return JSON.stringify(obj, null, 2); // 2 个空格缩进
      } catch (e) {
        return "Invalid JSON";
      }
    },
    DownloadnClick() {
      let params = {
        apiItemId: this.apiInfo.id,
        fileType: "enum",
      };
      downLoadFileByItemId(params).then((res) => {
        if (res.code == 200) {
          // 截取文件后缀名 查看属于什么文件
          let fileType = res.msg.split(".").pop().toLowerCase();
          var downloadType = "";
          if (fileType == "pdf") {
              downloadType = "application/pdf";
            } else if (fileType == "docx") {
              downloadType =
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            } else if (fileType == "doc") {
              downloadType = "application/msword";
            } else if (fileType == "xls") {
              downloadType = "application/vnd.ms-excel";
            } else if (fileType == "xlsx") {
              downloadType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            } else if (fileType == "csv") {
              downloadType = "text/csv;charset=utf-8";
            }
          downloadFromBase64(res.data, downloadType, res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
@import '../../../assets/css/DataLibraryDetail.css';
</style>
